import { AbsoluteFill, Html5Video } from "remotion";
import { Video } from "@remotion/media";
import { mediaPlaybackRate, mediaPreservePitch } from "../media-playback";
import { videoContentStyle } from "./video-crop-style";
import {
  useRemotionLayerVolume,
  type VideoLayerRenderProps,
} from "./use-audio-layer-media";

export function VideoLayer(props: VideoLayerRenderProps) {
  const volume = useRemotionLayerVolume(props);
  const rate = mediaPlaybackRate(props.playbackRate);
  const pitch = mediaPreservePitch(props.preservePitch);
  const { src, muted, content } = props;
  const style = videoContentStyle(content);
  // Export time-stretches with ffmpeg; Mediabunny pitch-shifts, so sped preview uses Html5Video.
  if (rate != null && rate !== 1) {
    return (
      <AbsoluteFill>
        <Html5Video
          src={src}
          volume={volume}
          muted={muted}
          playbackRate={rate}
          preservePitch={pitch}
          style={style}
        />
      </AbsoluteFill>
    );
  }
  return (
    <AbsoluteFill>
      <Video
        src={src}
        volume={volume}
        muted={muted}
        playbackRate={rate}
        style={style}
      />
    </AbsoluteFill>
  );
}
